import React, { useEffect, createElement } from 'react';
import { SalesPage } from './components/SalesPage';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    // Inject Meta Pixel
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '26257470350562748');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    return () => {
      // Cleanup if necessary, though usually pixel stays
    };
  }, []);
  return <>
      <SalesPage data-id="element-0" />
      <PurchasePopup data-id="element-1" />
    </>;
}